import React from "react";

import { Grid } from "@material-ui/core";
import {
  GiCowled,
  GiLaurelsTrophy,
  GiSevenPointedStar,
  GiSwordsPower,
} from "react-icons/gi";

import { paletas } from "../../../../styles/theme";
import { Wrapper, TituloRank, TabelaRank } from "./styles";
import { MostrarTodosUsuarios } from "../../../../servicos";

export default function Ranking() {
  const [listagemUsuarios, setListagemUsuarios] = React.useState<any>([]);

  React.useEffect(() => {
    pegarMelhoresUsuarios();
  }, []);

  const pegarMelhoresUsuarios = async () => {
    const dados = await MostrarTodosUsuarios();

    try {
      if (dados.success) {
        let ordenado: any[] = dados.data;

        ordenado.sort(function (a: any, b: any) {
          if (
            a.player_statistics.league_points <
            b.player_statistics.league_points
          ) {
            return 1;
          }
          if (
            a.player_statistics.league_points >
            b.player_statistics.league_points
          ) {
            return -1;
          }
          return 0;
        });

        setListagemUsuarios(ordenado);
      }
    } catch (err) {
      console.info("Falha de comunicação com o servidor");
    }
  };

  return (
    <Wrapper>
      <TituloRank>TEMPORADA 2021 - S1</TituloRank>
      <Grid container>
        <TabelaRank>
          <thead>
            <tr>
              <th>
                <GiSevenPointedStar color={paletas.OrangeDesaturado} /> PDL
              </th>
              <th>
                <GiCowled color={paletas.DarkOrange} /> DEVS
              </th>
              <th>
                <GiLaurelsTrophy color={paletas.Gold} /> LIGA
              </th>
              <th>
                <GiSwordsPower color={paletas.RedTheme} /> VITÓRIAS
              </th>
            </tr>
          </thead>
          <tbody>
            {listagemUsuarios &&
              listagemUsuarios.map((item: any, idx: number) => (
                <tr key={idx}>
                  <td>{item.player_statistics.league_points}</td>
                  <td>{item.name}</td>
                  <td>{item.player_statistics.league}</td>
                  <td>{item.player_statistics.winning_total}</td>
                </tr>
              ))}
          </tbody>
        </TabelaRank>
      </Grid>
    </Wrapper>
  );
}
